import { models } from '@ps/web-core-store';

import type { SelectorCreator, Slicer } from '@swf/core/store';

import type { AccountState } from './index';

const selectors = (slice: Slicer<AccountState>, createSelector: SelectorCreator) => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...models.account.selectors(slice as any, createSelector)
});

export default selectors;
